import { spawn } from "redux-saga/effects";

import surveySagas from 'modules/survey/sagas'

export default function* rootSaga() {
  yield spawn(surveySagas)
}
